<script>
    import { lang } from './store.js';
    import { detectedLang } from './detectedLang.js';

    let langs = ['En', 'Fr', 'He', 'Ar', 'Ru', 'Es'];

    if (langs[detectedLang] != 'undefined') {
        lang.set(detectedLang);
        //console.log('2:' + detectedLanguage);
    }

    window.location.replace('https://'+ $lang.toLowerCase() +'.site.edomedic.com/');
</script>